import anime from "animejs";
import Macy from "macy";

const convertRange = (value, r1, r2) => (value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0]


document.addEventListener('DOMContentLoaded', () => {
  var macy = Macy({
    container: '.content',
    trueOrder: false,
    columns: 3,
    margin: {
      x: 30,
      y: 25,
    },
    breakAt: {
      1300: {
        columns: 2,
        margin: {
          x: 20,
          y: 30,
        },
      }
    }
  });

  var d = new Date();
  var m = d.getMonth();
  console.log(m);

  const selectElement = document.querySelector('.months');
  selectElement.selectedIndex = m;

  const update = () => {
    document.querySelector('article').className = selectElement.value
    document.querySelector('.top h2').innerHTML = selectElement.value
    //macy.recalculate();
    macy.reInit();
  }

  update()

  selectElement.addEventListener('input', update);

  const mainEl = document.querySelector('main');
  const decor1 = document.querySelector('.leaf2');
  const decor2 = document.querySelector('.leaf1');
  const decor3 = document.querySelector('.blob1');
  const decor4 = document.querySelector('.blob2');

  const onScroll = (e) => {

    const range = convertRange(e.target.scrollTop, [0, mainEl.clientHeight], [0, 15])

    decor1.style.transform = `translateY(-${range * 1.3}px)`
    decor2.style.transform = `translateY(-${range}px)`
    decor3.style.transform = `translateY(-${range * 0.8}px)`
    decor4.style.transform = `translateY(-${range * 2}px)`

  };

  mainEl.addEventListener('scroll', onScroll);

}, false);